import React, { FC, MouseEvent } from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";
import { XHComponentCommonProps } from "../../types";
import "./index.scss";

export type MaskProps = {
  closeOnClickMask?: boolean;
  onClick?: (e: MouseEvent) => void;
  mask?: "transparent" | "normal";
  dataTrackId?: string;
} & XHComponentCommonProps;

const Mask: FC<MaskProps> = props => {
  const {
    closeOnClickMask = true,
    onClick,
    mask,
    dataTrackId = "Mask",
  } = props;

  const cls = classNames("xh-mask", {
    "xh-mask-normal": mask === "normal",
    "xh-mask-transparent": mask === "transparent",
  });

  function handleClick(e: any): void {
    closeOnClickMask && onClick && onClick(e);
  }

  return (
    <View
      className={cls}
      onClick={handleClick} //@ts-ignore
      dataTrackId={dataTrackId}
    />
  );
};

export default Mask;
